$(function () {
    $.fn.oldIs = $.fn.is;

    $.fn.is = function (selector) {
        if (selector === ":checked" && $(this).hasClass('widget-radio')) {
            return $(this).find("input[type=radio]").is(selector);;
        }
        else {
            return $(this).oldIs(selector);
        }
    }
});